import { put } from 'redux-saga/effects';
import jwt from 'jsonwebtoken';

import api from './../api';
import { tokenVerifySuccess, tokenVerifyFail, userFetch } from '../actions';

export function* tokenVerifySaga(action) {
  try {

    // Get token as parameter or from localStorage
    const token = action.token || localStorage.getItem('token');
    const response = yield api.auth.tokenRefresh(token);

    // Make sure response contains proper data
    if (!response || !response.data || !response.data.data || !response.data.data.token) {
      throw new Error('error in response');
    }

    // Handle response
    const newToken = response.data.data.token;
    const decoded = jwt.decode(newToken);
    const { userID, organizationID, exp } = decoded;

    if(!action.userID && userID) {
      yield put(userFetch(userID));
    }

    yield put(tokenVerifySuccess({ token: newToken, userID, organizationID, exp }));

  } catch (error) {
    yield put(tokenVerifyFail(error));
  }
}
